/**
 * A person as every patient form holds them: the therapist's new patient, the
 * therapist's edit of one, and a centre administrator's student. All text, as
 * typed, ready to validate with `validatePatient` and to send.
 */
export interface PersonDetails {
    first_name: string;
    last_name: string;
    contact_email: string;
    contact_phone: string;
    /** Optional; a national number is completed with `country` when sent. */
    whatsapp_phone: string;
    pronouns: string;
    /** `YYYY-MM-DD`, or empty. */
    date_of_birth: string;
    sex: string;
    street: string;
    city: string;
    state: string;
    postal_code: string;
    country: string;
    timezone: string;
}

export type PersonField = keyof PersonDetails;

/** The pronouns offered by name; anything else is written in. */
export const PRESET_PRONOUNS = ["he/him", "she/her", "they/them"] as const;

/** What a new form starts from. */
export function blankPersonDetails(): PersonDetails {
    return {
        first_name: "",
        last_name: "",
        contact_email: "",
        contact_phone: "",
        whatsapp_phone: "",
        pronouns: "",
        date_of_birth: "",
        sex: "",
        street: "",
        city: "",
        state: "",
        postal_code: "",
        country: "ES",
        timezone: "",
    };
}

type StoredPerson = Pick<PersonDetails, "first_name" | "last_name" | "contact_email" | "contact_phone"> &
    Partial<Record<Exclude<PersonField, "first_name" | "last_name" | "contact_email" | "contact_phone">, string | null>>;

/** A stored patient, as the form holds them: empty text for what is unknown. */
export function personDetailsFrom(patient: StoredPerson): PersonDetails {
    return {
        first_name: patient.first_name,
        last_name: patient.last_name,
        contact_email: patient.contact_email,
        contact_phone: patient.contact_phone,
        whatsapp_phone: patient.whatsapp_phone || "",
        pronouns: patient.pronouns || "",
        date_of_birth: patient.date_of_birth ? patient.date_of_birth.split("T")[0] : "",
        sex: patient.sex || "",
        street: patient.street || "",
        city: patient.city || "",
        state: patient.state || "",
        postal_code: patient.postal_code || "",
        country: patient.country || "ES",
        timezone: patient.timezone || "",
    };
}
